export default __webpack_public_path__ + "static/elotitos-movil-5d44d53a64f51a621941aaa4dfa8b45d.png";